import React, { useEffect, useState } from "react";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BranchDropDown,
  LoadingComponent,
  TrustDropDown,
} from "../../../../components/Component";
import { ImportExportButton } from "../../../../components/button/ActionButton";
import DateRangePicker from "../../../../components/input/date-time/DateRangePicker";
import { GradeTypeDropDownWithoutCarer } from "../../../../components/dropdowns/GradeTypeDropDown";
import Availabilitidata, { availabilitiesListApi, exportAvailabilitiesAPI } from "./AvailabilitiData";
import { getDates, showErrorToast } from "../../../../utils/Functions";
import { Spinner } from "reactstrap";

const Availabilitilist = () => {
  const [loading, setLoading] = useState(false);
  const [loadingbtn, setLoadingbtn] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [currentPage, setCurrentPage] = useState(1);
  const [availabilitiesListData, setavailabilitiesListData] = useState([]);
  const [grade, setGrade] = useState();
  const [matrixPageInfo, setMatrixPageInfo] = useState();
  const [hospitalData, setHospitalData] = useState();
  const [endDate, setEndDate] = useState("");
  const datesBetween = getDates(startDate, endDate);
  const itemsPerPage = 100;

  useEffect(() => {
    loadavailabilitiesList();
  }, [startDate, endDate, grade, hospitalData, currentPage]);
  function loadavailabilitiesList() {
    if (!startDate || !endDate) return;

    setLoading(true);
    let params = {
      pageInfo: {
        pageIndex: currentPage,
        itemsPerPage: itemsPerPage,
      },
      startDate: startDate,
      endDate: endDate,
      clientId: 0,
      trustId: hospitalData?.trust?.id ?? 0,
      gradeId: grade?.id ?? 0,
      branchId: hospitalData?.branch?.id ?? 0,
    };
    availabilitiesListApi(params, (data, error) => {
      if (error === null) {
        setMatrixPageInfo(data?.pageInfo);
        if (currentPage === 1) {
          setavailabilitiesListData(data?.list);
        } else {
          setavailabilitiesListData((prevList) => [...prevList, ...data?.list]);
        }
      } else {
        showErrorToast(error.message);
      }
      setLoading(false);
    });
  }
  const onExportClick = () => {
    if (!startDate && !endDate) return;
    setLoadingbtn(true);
    let params = {
      startDate: startDate,
      endDate: endDate,
      clientId: 0,
      trustId: hospitalData?.trust?.id ?? 0,
      gradeId: grade?.id ?? 0,
      branchId: hospitalData?.branch?.id ?? 0,
    };
    exportAvailabilitiesAPI(params, (data, error) => {
      if (error === null) {
        window.open(data?.fileUrl, "default");
      }
      setLoadingbtn(false);
    });
  };

  const handleDatePickerChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
    setCurrentPage(1);
  };
  return (
    <React.Fragment>
      <Head title="Availabilities" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Availabilities</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <ul className="nk-block-tools g-2 d-flex flex-wrap justify-content-end">
                <li>
                  <TrustDropDown
                    value={hospitalData?.trust}
                    selectedId={hospitalData?.trust?.id}
                    onSelect={(trust) => {
                      setHospitalData((prev) => ({
                        ...prev,
                        trust: trust,
                      }));
                      setCurrentPage(1); // Reset page to 1
                    }}
                    className="w-225px"
                    isFirstSelected={true}
                    placeholder={"select Trust"}
                  />
                </li>
                <li>
                  <BranchDropDown
                    value={hospitalData?.branch}
                    selectedId={hospitalData?.branch?.id}
                    onSelect={(branch) => {
                      setHospitalData((prev) => ({
                        ...prev,
                        branch: branch,
                      }));
                      setCurrentPage(1); // Reset page to 1
                    }}
                    isClearable
                    className="w-225px"
                    placeholder={"select Area Manager"}
                  />
                </li>
                <li>
                  <GradeTypeDropDownWithoutCarer
                    value={grade}
                    isClearable
                    isShowAll
                    className="w-225px"
                    placeholder="Grade Type"
                    onSelect={(selectedGrade) => {
                      setGrade(selectedGrade);
                      setCurrentPage(1); // Reset page to 1
                    }}
                  />
                </li>

                <li>
                  <DateRangePicker onDateChange={handleDatePickerChange} />
                </li>

                {availabilitiesListData?.length > 0 && (
                  <li>
                    <ImportExportButton
                      title="Export"
                      iconName="arrow-up"
                      loading={loadingbtn}
                      onClick={onExportClick}
                    />
                  </li>
                )}
              </ul>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Availabilitidata
            hList={datesBetween}
            vList={availabilitiesListData}
            currentPage={currentPage}
            matrixPageInfo={matrixPageInfo}
            loading={loading}
            setCurrentPage={setCurrentPage}
          />
        </Block>
        {loading && (
          <div className="table-loader">
            <Spinner className="spinner-border-md" color="primary" />
          </div>
        )}
      </Content>
    </React.Fragment>
  );
};

export default Availabilitilist;
